<div [@dialog] (@dialog.done)="animationEnded($event)" *ngIf="visible" class="dialogModal"
  [style.width]="modalWidth ? modalWidth: ''" [style.top]="modalTop ? modalTop: ''"
  [style.min-height]="modalMinHeight ? modalMinHeight: ''">
  <ng-content></ng-content>
  <button type="button" *ngIf="closable" (click)="close()" aria-label="Close" class="dialogModal__close-btn"
    [style.color]="closeColor"><i class="fa fa-times" aria-hidden="true"><strong><a href="javascript:void()" style="color: white;">x</a>
    </strong> </i></button>
</div>
<div *ngIf="visible" class="overlay" (click)="cancelable && close()"></div>
